import BenchlingConfig from 'BenchlingConfig';
import {FolderPreferences} from 'constants/FolderConstants';
import {Section} from 'constants/NavConstants';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import preferences from 'Preferences';
import {Optional} from 'util/Types';

// Please keep in sync with benchling/folders/folder_defaults.py
export enum FolderDefaultsKey {
  ANALYSIS = 'analysis',
  ANTIBODY = 'antibody',
  BULK_MODEL_PREDICTION = 'bulk_model_prediction',
  DATASET = 'dataset',
  FIND_OLIGO = 'find-oligo',
  INVENTORY = 'inventory',
  JELLYFISH = 'jellyfish',
  NOTEBOOK = 'notebook',
  OLIGO = 'oligo',
  PROCESS = 'process',
  PROCESS_EXECUTION_ENTRY = 'process_execution_entry',
  REQUESTS_V2 = 'requests_v2',
  STUDIES = 'studies',
  WORKFLOWS = 'workflows',
  WORKSHEET = 'worksheet',
}

// `default_folder` is used both here and in folder_defaults.py
const FolderDefaults = {
  get(key: FolderDefaultsKey): Optional<string> {
    if (
      BenchlingConfig.NAVIGATION_USE_OPEN_FOLDER_AS_DEFAULT &&
      SidepanelStore.getSection() === Section.PROJECT_ITEMS
    ) {
      const folder = SidepanelStore.getListedFolder(Section.PROJECT_ITEMS);
      if (folder) {
        return folder.api_identifier;
      }
    }
    return preferences.get(`${FolderPreferences.DEFAULT_FOLDER_NAMESPACE}${key}`);
  },

  getList(key: FolderDefaultsKey): Optional<Array<string>> {
    return preferences.get(`${FolderPreferences.DEFAULT_FOLDER_LIST_NAMESPACE}${key}`);
  },

  set(key: FolderDefaultsKey, folderId: string): void {
    preferences.set(`${FolderPreferences.DEFAULT_FOLDER_NAMESPACE}${key}`, folderId);
  },

  setList(key: FolderDefaultsKey, folderIdList: Array<string>): void {
    preferences.set(`${FolderPreferences.DEFAULT_FOLDER_LIST_NAMESPACE}${key}`, folderIdList);
  },

  unset(key: FolderDefaultsKey): void {
    preferences.unset(`${FolderPreferences.DEFAULT_FOLDER_NAMESPACE}${key}`);
  },
};

export default FolderDefaults;
